// Phone area-code lists — sourced from resources/data/area-codes/latest.json,
// generated by `php artisan phone-area-codes:sync` from the authoritative NANPA
// NPA report. DO NOT edit these lists by hand — re-run the sync command instead.
//
//   ca        -> CANADIAN_AREA_CODES  (COUNTRY=CANADA, geographic)
//   us        -> US_AREA_CODES        (COUNTRY=US, geographic)
//   toll_free -> TOLL_FREE_AREA_CODES
import areaCodes from '../../data/area-codes/latest.json';

export const CANADIAN_AREA_CODES = areaCodes.ca ?? [];
export const US_AREA_CODES = areaCodes.us ?? [];
export const TOLL_FREE_AREA_CODES = areaCodes.toll_free ?? [];
